import { ActionContext } from "vuex";
interface AuthState {
  user: Record<string, any> | null;
  isAuthenticated: boolean;
}

const state = {
  isAuthenticated: false,
};

const getters = {
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
};

const mutations = {
  SET_USER_AUTHENTICATION_STATUS(state: AuthState, status: boolean) {
    state.isAuthenticated = status;
   }
};

const actions = {  
  setUserAuthenticationStatus({ commit }: ActionContext<AuthState, any>, status: boolean) {
    commit("SET_USER_AUTHENTICATION_STATUS", status);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
